<template>
  <el-dialog
    :visible="visible"
    :show-close="false"
    width="70%"
    top="10vh"
    class="edit-detail-dialog"
    center
    @close="handleDialogClose"
    :close-on-click-modal="false">
    <span slot="title" class="title-container">
      <span class="title-text">{{factoryName + $t('factoryLabelPrint.templateContentEditing')}}</span>
      <img
        src="@/assets/close.png"
        class="close-image"
        @click="close"
      />
    </span>
    <el-form class="el-form" :model="form" ref="refForm" :rules="rules" label-width="120px">
      <el-form-item label-width="0">
        <el-col :span="10">
          <el-form-item :label="$t('factoryLabelPrint.specificationNo') + ':'" prop="partNo">
            <el-input
              v-model.trim="form.partNo"
              name="partNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item :label="$t('factoryLabelPrint.productionDate') + ':'" prop="deliveryDate">
            <el-date-picker
              v-model="form.deliveryDate"
              type="month"
              size="small"
              style="width: 100%;">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="10">
          <el-form-item :label="$t('factoryLabelPrint.qiangLiBatchNo') + ':'" prop="trackingNo">
            <el-input
              v-model.trim="form.trackingNo"
              name="batchNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
              placeholder="001-999">
              <template slot="prepend">IC56-{{deliveryDateVal}}</template>
              <el-select v-model="form.qiangLiAppend" slot="append" placeholder="请选择">
                <el-option label="无" value=""></el-option>
                <el-option label="-A" value="-A"></el-option>
                <el-option label="-A-SP" value="-A-SP"></el-option>
                <el-option label="-TC" value="-TC"></el-option>
              </el-select>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item :label="$t('factoryLabelPrint.lotNoOfOutBox') + ':'" prop="lotNoOfOutBox">
            <el-input
              v-model.trim="form.lotNoOfOutBox"
              name="lotNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0" v-for="(item, index) in form.reserveInfo" :key="index">
        <el-col :span="10">
          <el-form-item :label="$t('common.lotNo') + ':'" :prop="'reserveInfo.' + index + '.lotNo'" :rules="rules.lotNo">
            <el-input
              v-model.trim="item.lotNo"
              name="lotNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item :label="$t('common.count')" :prop="'reserveInfo.' + index + '.cnt'" :rules="rules.count">
            <el-input
              v-model.trim.number="item.cnt"
              name="count"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="9"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-button type="text" @click="addReserve(index)" style="margin-left: 5px;">{{$t('common.add')}}</el-button>
          <el-button type="text" :disabled="form.reserveInfo.length === 1" @click="deleteReserve(index)">{{$t('common.delete')}}</el-button>
        </el-col>
      </el-form-item>
      <el-form-item :label="$t('common.stylePreview') + ':'" style="margin-bottom: 0">
      </el-form-item>
      <el-form-item>
        <el-col :span="15">
          <iframe
            id="labelIFrameQiangliBoxDialog"
            scrolling="auto"
            width="520"
            height="260"
            frameborder="0"
            style="background: #E9E9E9;"
          ></iframe>
        </el-col>
      </el-form-item>
    </el-form>
    <span slot="footer">
        <el-button size="small" @click="close">{{$t('common.cancel')}}</el-button>
        <el-button
          size="small"
          type="primary"
          @click="submitForm">
            {{$t('common.print')}}
        </el-button>
      </span>
  </el-dialog>
</template>

<script>
import {
  validateCount,
  validateLotNo,
} from '@/utils/validate';
import {initQiangLiBoxLabelFrame, printFactoryLabel} from "@/utils/factory-label";
import moment from "moment";
import i18n from "@/lang";

export default {
  name: "QiangLiBoxLabelDialog",
  props: {
    factoryName: {
      type: String,
      default: '',
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const validateQiangLiBatchNo = (rule, value, callback) => {
      if (!/^(00[1-9]|0[1-9][0-9]|[1-9]\d{2})$/.test(value)) {
        callback(new Error(i18n.t('factoryLabelPrint.qiangLiBatchNoFormatIncorrect')));
        return;
      }
      callback();
    };
    return {
      form: {
        partNo: undefined,
        deliveryDate: undefined,
        trackingNo: undefined,
        qiangLiAppend: '',
        lotNoOfOutBox: undefined,
        reserveInfo: [{
          lotNo: undefined,
          cnt: undefined,
        }],
      },
      rules: {
        partNo: [{
          required: true,
          trigger: 'blur',
          message: this.$t('factoryLabelPrint.specificationNoCanNotBeEmpty')
        }],
        deliveryDate: [{
          required: true,
          trigger: 'blur',
          message: this.$t('factoryLabelPrint.productionDateCanNotBeEmpty')
        }],
        trackingNo: [{
          required: true,
          trigger: 'blur',
          message: this.$t('factoryLabelPrint.qiangLiBatchNoCanNotBeEmpty')
        }, {
          required: true,
          trigger: 'blur',
          validator: validateQiangLiBatchNo
        }],
        lotNoOfOutBox: [{
          required: true,
          trigger: 'blur',
          message: this.$t('factoryLabelPrint.lotNoOfOutBoxCanNotBeEmpty')
        }],
        lotNo: [{
          required: true,
          trigger: 'blur',
          validator: validateLotNo
        }],
        count: [{
          required: true,
          trigger: 'blur',
          validator: validateCount
        }],
      }
    }
  },
  watch: {
    visible(newValue) {
      if (newValue) {
        setTimeout(() => {
          this.initQiangLiBoxLabelFrame();
        });
      }
    }
  },
  computed: {
    deliveryDateVal() {
      const {
        deliveryDate,
      } = this.form;
      if (!deliveryDate) {
        return '';
      }
      return moment(deliveryDate).format('YYMM') + '-';
    }
  },
  methods: {
    handleDialogClose() {
      this.close();
    },
    close() {
      this.$emit('update:visible', false);
      this.$emit('close');
      if (this.$refs.refForm && typeof this.$refs.refForm.clearValidate === 'function') {
        this.$refs.refForm.clearValidate();
      }
    },
    addReserve(index) {
      this.form.reserveInfo.splice(index + 1, 0, {
        lotNo: undefined,
        cnt: undefined,
      });
    },
    deleteReserve(index) {
      this.form.reserveInfo.splice(index, 1);
      if (this.form.reserveInfo.length !== index) {
        this.$refs.refForm.validateField(['reserveInfo.' + index + '.lotNo', 'reserveInfo.' + index + '.cnt']);
      }
    },
    submitForm() {
      this.$refs.refForm.validate(async (valid) => {
        if (valid) {
          this.printQiangLiBoxLabelFrame();
        }
      });
    },
    initQiangLiBoxLabelFrame() {
      let iframe = document.getElementById('labelIFrameQiangliBoxDialog');
      iframe = initQiangLiBoxLabelFrame({
        iframe,
        partNo: 'LS9929S SSOP24 卷装',
        lotNo: 'YZH-3',
        trackingNo: 'IC56-1805-001',
        reserveInfo: [{
          lotNo: 'YZH',
          cnt: 4000,
        }, {
          lotNo: 'YZHA',
          cnt: 2600,
        }, {
          lotNo: 'YZHB',
          cnt: 2500,
        }]
      });
      iframe.contentWindow.document.close();
    },
    printQiangLiBoxLabelFrame() {
      const {
        partNo,
        lotNoOfOutBox,
        trackingNo,
        reserveInfo,
        qiangLiAppend,
      } = this.form;
      let iframe = document.getElementById('labelIFrameQiangliBoxDialog');
      let i = 0;
      let lotNoIndex = 0;
      let info = [];
      for (let row of reserveInfo) {
        i++;
        info.push(row);
        if (i % 4 === 0) {
          lotNoIndex++;
          iframe = initQiangLiBoxLabelFrame({
            iframe,
            partNo,
            lotNo: lotNoOfOutBox,
            trackingNo: `IC56-${this.deliveryDateVal}${trackingNo}${qiangLiAppend || ''}` ,
            reserveInfo: info,
            index: lotNoIndex === 1 ? 0 : lotNoIndex, // 标签分页
            lotNoIndex: reserveInfo.length > 4 ? lotNoIndex : '',
          });
          info = [];
        }
      }
      if (info.length > 0) {
        lotNoIndex++;
        iframe = initQiangLiBoxLabelFrame({
          iframe,
          partNo,
          lotNo: lotNoOfOutBox,
          trackingNo: `IC56-${this.deliveryDateVal}${trackingNo}${qiangLiAppend || ''}` ,
          reserveInfo: info,
          index: lotNoIndex === 1 ? 0 : lotNoIndex, // 标签分页
          lotNoIndex: reserveInfo.length > 4 ? lotNoIndex : undefined,
        });
      }
      iframe.contentWindow.document.close();
      printFactoryLabel(iframe);
    },
  }
}
</script>

<style scoped>
.title-container {
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  justify-content: space-between;
  background: -webkit-linear-gradient(#F9F9F9, #EEEEEE);
  background: -o-linear-gradient(#F9F9F9, #EEEEEE);
  background: -moz-linear-gradient(#F9F9F9, #EEEEEE);
  background: linear-gradient(#F9F9F9, #EEEEEE);
  padding: 10px 15px;
  align-items: center;
}

.title-text {
  color: #404040;
  font-size: 16px;
}

.el-form {
  margin: 0 30px;
}

.close-image {
  width: 22px;
  height: 22px;
  cursor: pointer;
  padding: 0 10px;
}
/deep/ .el-input-group__append {
  width: 70px;
}
</style>
<style>
  .edit-detail-dialog .el-dialog__header {
    padding: 0;
  }
</style>
